import * as React from 'react';
import { GridColumnMenuFilter, GridColumnMenuCheckboxFilter } from '@progress/kendo-react-grid';
import { DateFilterCell } from './Grid/Cell/DateFilterCell';

export const CustomColumnMenu = props => {
    const dateFormatFilter = props.dateFormatFilter;

    if (props.checkboxFilter) {
        let sortedData = props.data.map(x => x).sort((a, b) => {
            let aField = a[props.column.field]?.toString();
            if (!aField)
                return -1;
            let bField = b[props.column.field]?.toString();
            if (!bField)
                return 1;
            return aField.localeCompare(bField);
        });
        return <div>
            <GridColumnMenuCheckboxFilter
                {...props}
                data={sortedData}
                expanded={true}
                searchBox={() => null}
            />
        </div>;
    }
    else
        return <div>
            <GridColumnMenuFilter
                {...props}
                onExpandChange={() => { } }
                expanded={true}
                filterUI={props.useDateFilter ? (props) => <DateFilterCell {...props} dateFormatFilter={dateFormatFilter} /> : false}
            />
        </div>;
};